(() => {
  const moved = new Map();
  function restore(node) {
    const anchor = moved.get(node);
    if (anchor?.isConnected) anchor.after(node);
  }
  function place(node, target) {
    if (!moved.has(node)) {
      const anchor = document.createComment('Snovera original position');
      node.before(anchor);
      moved.set(node, anchor);
    }
    target.append(node);
  }
  function arrange() {
    for (const [node, anchor] of moved) if (!node.isConnected) { anchor.remove(); moved.delete(node); }
    const info = document.querySelector('.product__info-container');
    const gallery = document.querySelector('.product__media-wrapper');
    if (!info || !gallery) return;
    const desktop = matchMedia('(min-width: 990px)').matches;
    const accordions = [...document.querySelectorAll('.product__accordion')];
    const media = document.querySelector('.sn2-hero_videos')?.closest('.shopify-section');
    accordions.forEach(node => desktop ? place(node, gallery) : restore(node));
    if (media) desktop ? place(media, gallery) : restore(media);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrange); else arrange();
  matchMedia('(min-width: 990px)').addEventListener('change', arrange);
  document.addEventListener('shopify:section:load', arrange);
  document.addEventListener('shopify:section:reorder', arrange);
})();

(() => {
  function syncPrice(box) {
    if (box.closest('[id^="MainProduct-"]')?.querySelector('[data-sn-offer-config]')) return;
    const selected = box.querySelector('input[type="radio"]:checked');
    const label = selected?.nextElementSibling;
    const price = label?.querySelector('.quantity-break__price')?.textContent.trim();
    const compare = label?.querySelector('.quantity-break__compare-price')?.textContent.trim();
    const main = box.closest('[id^="MainProduct-"]');
    if (!main || !price) return;
    main.querySelectorAll('[id^="main-atc-price-"]').forEach(el => el.textContent = '| ' + price);
    main.querySelectorAll('.main-price').forEach(el => el.textContent = price);
    if (compare) main.querySelectorAll('.main-comapre-price').forEach(el => el.textContent = compare);
    main.querySelectorAll('[id^="sticky-atc-separate-price-"] .price-item--sale').forEach(el => el.textContent = price);
    main.querySelectorAll('[id^="sticky-atc-separate-price-"] .price__sale .price-item--regular').forEach(el => el.textContent = compare || price);
  }
  function init(scope = document) {
    scope.querySelectorAll('quantity-breaks').forEach(box => {
      if (box.closest('[id^="MainProduct-"]')?.querySelector('[data-sn-offer-config]')) return;
      if (box.dataset.snPriceBound) return;
      box.dataset.snPriceBound = 'true';
      box.querySelectorAll('input[type="radio"]').forEach(input => {
        const label = input.nextElementSibling?.querySelector('.quantity-break__label')?.textContent.trim();
        if (label) input.setAttribute('aria-label',label);
      });
      box.addEventListener('change', () => requestAnimationFrame(() => syncPrice(box)));
      new MutationObserver(() => syncPrice(box)).observe(box,{subtree:true,childList:true,characterData:true});
      syncPrice(box);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
